import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { rememberUser } from "../hooks/useUserState";

const API = process.env.REACT_APP_BACKEND_URL;

/* Handles the `#session_id=...` fragment Emergent's managed Google auth returns.
   REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH */
export const AuthCallback = () => {
  const navigate = useNavigate();
  const processed = useRef(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const sessionId = new URLSearchParams((window.location.hash || "").replace(/^#/, "")).get("session_id");
    let next = "/dashboard";
    try {
      const stored = sessionStorage.getItem("pr.auth.next");
      if (stored && stored.startsWith("/")) next = stored;
    } catch { /* storage unavailable */ }

    (async () => {
      if (!sessionId) { navigate("/login", { replace: true }); return; }
      try {
        const res = await fetch(`${API}/api/auth/google/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!res.ok) throw new Error("google session exchange failed");
        const data = await res.json().catch(() => ({}));
        if (data?.email) rememberUser(data.email);
        try { sessionStorage.removeItem("pr.auth.next"); } catch { /* noop */ }
        navigate(next, { replace: true });
      } catch {
        setFailed(true);
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: "#FAF7F0" }} data-testid="auth-callback">
      {failed ? (
        <div className="max-w-sm w-full text-center rounded-2xl p-8 border" style={{ background: "#FFFFFF", borderColor: "#E8E2D5" }}>
          <p className="text-lg font-bold mb-2" style={{ fontFamily: "'Fraunces', Georgia, serif", color: "#2A1E5C" }}>
            That sign-in didn't go through
          </p>
          <p className="text-sm mb-5" style={{ color: "#5D5A6B" }}>
            Your Google session expired before we could finish. One more try usually does it.
          </p>
          <Link
            to="/login"
            className="inline-block px-6 py-3 rounded-full font-bold text-sm"
            style={{ background: "#F5CB5C", color: "#2A1E5C" }}
            data-testid="auth-callback-retry"
          >
            Back to sign in
          </Link>
        </div>
      ) : (
        <p className="text-sm" style={{ color: "#5D5A6B" }}>Signing you in…</p>
      )}
    </div>
  );
};

export default AuthCallback;
